/**
 * Keller Meister — apply Shopify browsing_context_suggestions (IP / browser context)
 * once per browser session when confidence is high enough.
 *
 * @see https://shopify.dev/docs/storefronts/themes/markets/localization-discovery
 */
(function () {
  var SESSION_KEY = 'km_loc_discovery_v1';
  var MIN_CONFIDENCE = 0.65;

  function getCfg() {
    return window.kmLocalizationDiscovery;
  }

  function shouldSkip() {
    var cfg = getCfg();
    if (!cfg || !cfg.enabled) return true;
    if (window.Shopify && window.Shopify.designMode) return true;
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem(SESSION_KEY)) return true;
    return false;
  }

  function markDone() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {
      /* private mode */
    }
  }

  function suggestionTargets(s0, cfg) {
    if (!s0 || typeof s0.confidence !== 'number' || s0.confidence < MIN_CONFIDENCE) return null;
    var parts = s0.parts || {};
    var nextCountry = (parts.country && parts.country.handle) || cfg.currentCountry;
    var nextLang = (parts.language && parts.language.handle) || cfg.currentLanguage;
    if (!nextCountry || !nextLang) return null;
    if (nextCountry === cfg.currentCountry && nextLang === cfg.currentLanguage) return null;
    return { country: String(nextCountry).toUpperCase(), language: String(nextLang).toLowerCase() };
  }

  function submitLocalization(localizationRoot, country, language) {
    var root = localizationRoot.endsWith('/') ? localizationRoot : localizationRoot + '/';
    var returnTo = window.location.pathname + window.location.search + window.location.hash;
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = root + 'localization';
    form.setAttribute('accept-charset', 'UTF-8');
    form.style.display = 'none';

    var fields = {
      utf8: '✓',
      form_type: 'localization',
      _method: 'put',
      country_code: country,
      language_code: language,
      return_to: returnTo,
    };
    Object.keys(fields).forEach(function (name) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }

  function run() {
    if (shouldSkip()) return;
    var cfg = getCfg();

    var shopRoot =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || cfg.rootPath || '/';
    var base = shopRoot.endsWith('/') ? shopRoot : shopRoot + '/';
    var url =
      base +
      'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true';

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('suggestions HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var s0 = data.suggestions && data.suggestions[0];
        var targets = suggestionTargets(s0, cfg);
        markDone();
        if (targets) {
          submitLocalization(base, targets.country, targets.language);
        }
      })
      .catch(function () {
        markDone();
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
